declare const __ucCmp: any;

const reommendationForm: HTMLFormElement = document.querySelector("#RecomendationForm") as HTMLFormElement;
const tokenFormElement: HTMLInputElement = document.querySelector("input[name=RecaptchaToken]") as HTMLInputElement;
const siteKeyFormElement: HTMLInputElement = document.querySelector("#siteKey") as HTMLInputElement;
const receiverMailFormElement: HTMLInputElement = document.querySelector(
	"input[name=ReceiverEmail]"
) as HTMLInputElement;
const senderMailFormElement: HTMLInputElement = document.querySelector("input[name=SenderEmail]") as HTMLInputElement;
const recaptchaId = "Hko_qNsui-Q";
declare const grecaptcha: any;

/**
 * Callback funktion. Wird von Recaptcha aufgerufen
 * @param token Recaptcha Token
 */
async function OnRecommendationSubmit(ev: Event): Promise<void> {
	const details = await __ucCmp.getConsentDetails();
	const recaptchaAllowed = details.services[recaptchaId].consent.given;

	if (!recaptchaAllowed) {
		ev.preventDefault();
		return;
	}

	let formIsValid = true;

	if (!receiverMailFormElement.value) {
		formIsValid = false;
		receiverMailFormElement.setAttribute("style", "border-color: #de343a");
	}
	if (!senderMailFormElement.value) {
		formIsValid = false;
		senderMailFormElement.setAttribute("style", "border-color: #de343a");
	}

	if (!formIsValid) {
		ev.preventDefault();
	}

	grecaptcha.ready(function() {
		grecaptcha
			.execute(siteKeyFormElement.value, { action: "submit" })
			.then(function(token) {
				if (token === "") {
					ev.preventDefault();
				}
				tokenFormElement.value = token;
				reommendationForm.submit();
			})
			.catch(function() {
				ev.preventDefault();
			});
	});
}

export const RecommendationFormSubmit = (): void => {
	reommendationForm.addEventListener("submit", OnRecommendationSubmit);
};
